<cc-mapping-detect-prefix *ngIf="editMode" [form]="form"></cc-mapping-detect-prefix>
<div *ngIf="!editMode">
  <cc-msisdn
    [msisdn]="{isoCountry: form.get('isoCountry').value, label: form.get('pattern').value}"
    [small]="true"></cc-msisdn>
</div>
